module.exports = {"650421100":"鄯善镇","650421101":"七克台镇","650421102":"火车站镇","650421103":"连木沁镇","650421104":"鲁克沁镇","650421200":"辟展乡","650421201":"东巴扎回族民族乡","650421202":"吐峪沟乡","650421203":"达朗坎乡","650421204":"迪坎乡","650421400":"南山矿区","650421500":"园艺场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650421.json
// module id = 2847
// module chunks = 0